import { Tag, Input, Space, Table, TableProps } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useRef, useState } from 'react';
import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Button, message, Upload } from 'antd';
import { CustomAxios } from "../../services/api";
import MessageListPopUp from "./message.list.modal";
import Dragger from "antd/es/upload/Dragger";

    interface TagPopUpProps {
        agentSeq?: any;
        clubSeq?: any;
        selectedRecord: any;
        tagAry: string[];
        
    }
    const MessagePopUp: React.FC<TagPopUpProps> = ({ selectedRecord, tagAry ,agentSeq ,clubSeq}) => {
   
    const [checkedTags, setCheckedTags] = useState<{ [key: string]: boolean }>({}); // 체크된 태그 상태 추가
    const handleCheckboxChange = (tag: string, checked: boolean) => {
        setCheckedTags({ ...checkedTags, [tag]: checked }); // 체크된 태그 상태 업데이트
    };
    const handleOk = () => {
        console.log("Checked selectedRecord?.clubMemberSeq:", selectedRecord?.clubMemberSeq); 
        console.log("Checked checkedTags:", checkedTags); 

        const memoSettingData = {
            clubMemberSeq: Number(selectedRecord?.clubMemberSeq),
            memoData: JSON.stringify({ "회원태그": Object.entries(checkedTags).map(([key, value]) => ({ [key]: value })) })
        };
       
        console.log(" memoSettingData:", memoSettingData);

        CustomAxios.patchUserMemoSetting(memoSettingData)
        .then((response:any) => {
          console.log("postStudyCreateFile", response); 
        })
        .catch((err:any) => {
          console.log("postStudyCreateFile error", err);
        });        
    };

    useEffect(() => {
        setRefresh(Date.now());
        const newCheckedTags: { [key: string]: boolean } = {};
        tagAry.forEach(tag => {
            newCheckedTags[tag] = selectedRecord.memoData.includes(tag);
        });
        setCheckedTags(newCheckedTags);
    }, [tagAry]);


    const [textAreaValue, setTextAreaValue] = useState<string>('');
    
    const [fileList, setFileList] = useState<any[]>([]);
    const props: UploadProps = {
        onRemove: (file) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          setFileList(newFileList);
        },
        beforeUpload: (file) => {
          setFileList([...fileList, file]);
    
          return false;
        },
        fileList,
      };
    // TextArea 값 변경 이벤트 핸들러
    const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setTextAreaValue(e.target.value);
    };
    // 파일 업로드 상태 변경 이벤트 핸들러
    const handleFileChange = ({ fileList }: { fileList: any[] }) => {
        setFileList(fileList);
    };
    // 메시지 전송 버튼 클릭 이벤트 핸들러
    const handleSendMessage = () => {

       
        // 여기에서 POST 요청을 보내는 로직 구현
        // textAreaValue와 fileList를 사용하여 요청을 구성하고 보냄
        console.log('TextArea 값:', textAreaValue);
        console.log('파일 정보:', fileList);
        console.log('clubSeq:', clubSeq);
        console.log('selectedRecord?.memberId:', selectedRecord?.memberId);

        const formData = new FormData();

        if (fileList.length > 0 && fileList[0]?.originFileObj) {
            // 파일이 있을 때 파일을 추가
            //formData.append("files", fileList[0].originFileObj);
        } else {
            // 파일이 없을 때 빈 파일 추가
            const emptyFile = new Blob([], { type: "application/octet-stream" });
            formData.append("files", emptyFile, "empty_file.txt");
        }
        fileList.forEach(file => {
            formData.append("files", file.originFileObj);
        });
        

        const jsonData = {
            clubSeq: clubSeq,
            title: "[라임카드]알림",
            message: textAreaValue,
            receiverMemberId: [selectedRecord?.memberId]
        };
        const blob = new Blob([JSON.stringify(jsonData)], {
            type: "application/json",
          });

        formData.append("personalMessageDto", blob);

        CustomAxios.postPersonalMessageCreate(formData)
        .then((response) => {
          console.log("postStudyCreateFile", response);
          setFileList([]);
          setTextAreaValue("");
          
          message.info('메시지가 전송되었습니다.');
          setRefresh(Date.now());
        })
        .catch((err) => {
          console.log("postStudyCreateFile error", err);
          setRefresh(Date.now());
        });

    };

    const timestamp = Date.now();
    const [refresh, setRefresh] = useState(timestamp);

    return (
        <div style={{ height: '650px', overflowY: 'auto' }}>
         <p>
         {tagAry.map((tag, index) => (
                    <>
                    <input 
                    key={`tag_${index}`} 
                    type="checkbox" 
                    id={`tag_${index}`} 
                    name={`tag_${index}`} 
                    value={tag} 
                    checked={checkedTags[tag] || false} // 체크된 태그인지 확인하여 checked 속성 설정
                    onChange={(e) => handleCheckboxChange(tag, e.target.checked)} // 체크 상태 변경 핸들러
                    />
                    <label htmlFor={`tag_${index}`}>{tag}</label>
                    </>
                 ))}
                  <Button type="primary" style={{  width: 100, marginLeft : 10 }} icon={<UploadOutlined />} onClick={handleOk}>태그변경</Button>
         </p>
         <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>            
          <TextArea rows={7} placeholder="메시지작성" value={textAreaValue} onChange={handleTextAreaChange}/>        
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop : 10, marginBottom : 10 }}>
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
           
            <Dragger {...props}
            style={{ width: '100%' }}
            fileList={fileList}
            onChange={handleFileChange}
            multiple={true}
            >   
            {/* <p className="ant-upload-drag-icon"><InboxOutlined /></p> */}
            <p className="ant-upload-text"><InboxOutlined /> Click or drag file to this area to upload</p>                
            </Dragger>

            </div>   
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>           
            <Button type="primary" style={{  width: '100%' }} icon={<UploadOutlined />} onClick={handleSendMessage}>메시지전송</Button>
            </div>          
        </div>

        <MessageListPopUp refresh={refresh} selectedRecord={selectedRecord} agentSeq={agentSeq} clubSeq={clubSeq}></MessageListPopUp>
        </div>        
    );
}
export default MessagePopUp;

